import { render, staticRenderFns } from "./PriceFormatter.vue?vue&type=template&id=26407f21&scoped=true"
import script from "./PriceFormatter.vue?vue&type=script&lang=js"
export * from "./PriceFormatter.vue?vue&type=script&lang=js"
import style0 from "./PriceFormatter.vue?vue&type=style&index=0&id=26407f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26407f21",
  null
  
)

export default component.exports